import { AvailableModules } from 'generated/featureDefinitions'
import { EngagementSettingsRootPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { isModuleAvailabilityEnabled } from 'modules/core/lib/isModuleAvailabilityEnabled'

import CollectionsBootstrap from 'modules/engagement/lib/SettingsCollectionsBootstrap'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { EmployeePulseConfig } from './EmployeePulseConfig'
import { OneOnOnesMeetingsConfig } from './OneOnOnesMeetingsConfig'

const RootPage = () => {
  const { company } = useCurrentSession()
  const { data, loading, networkActivity } = useQuery(EngagementSettingsRootPageDocument, {
    variables: {
      companyIds: company.id,
      moduleAvailabilityIds: [
        AvailableModules.engagement_insights,
        AvailableModules.enps,
        AvailableModules.surveys,
      ],
    },
  })
  const settings = data?.engagement?.settings.at(0)
  const moduleAvailabilities = data?.companies?.moduleAvailabilitiesConnection?.nodes ?? []
  const canRequestUpsell = data?.upsell?._policies?.canRequestUpsell?.can ?? false

  const hasSurveys =
    moduleAvailabilities &&
    isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.surveys)
  const hasEnps =
    moduleAvailabilities && isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.enps)
  const hasEngagementInsights =
    moduleAvailabilities &&
    isModuleAvailabilityEnabled(moduleAvailabilities, AvailableModules.engagement_insights)

  const hasEngagement = hasSurveys || hasEnps || hasEngagementInsights
  const canSeeMeetings = data?.meetings._policies.seeMeetings.can ?? false
  const meetingsSettings = data?.meetings.settingsConnection.nodes[0] ?? undefined

  return (
    <CollectionsBootstrap>
      <ResponsivePage.Body loading={loading || !settings} error={null} showHeader={false}>
        {settings && (
          <>
            <EmployeePulseConfig
              settings={settings}
              advancedConfigurationEnabled
              hasEngagement={hasEngagement}
              canRequestUpsell={canRequestUpsell}
            />
            {canSeeMeetings && (
              <OneOnOnesMeetingsConfig
                settings={meetingsSettings}
                loading={loading || networkActivity}
              />
            )}
          </>
        )}
      </ResponsivePage.Body>
    </CollectionsBootstrap>
  )
}

export default RootPage
